
/* injects from baggage-loader */

export const SHOW_TOAST = 'SHOW_TOAST'
export const CLOSE_TOAST = 'CLOSE_TOAST'
export const CANCEL_TOAST_CLOSING = 'CANCEL_TOAST_CLOSING'

const initialState = {
  list: []
}

export default function toaster(state = initialState, action) {
  switch (action.type) {
    case SHOW_TOAST:
      return {
        ...state,
        list: [
          ...(state.list || []),
          {
            message: action.message,
            options: action.options,
            id: action.id
          }
        ]
      }
    case CLOSE_TOAST:
      const index = state.list.findIndex(item => item.id === action.id)
      if (index === -1) {
        return state
      }

      return {
        ...state,
        list: [
          ...state.list.slice(0, index),
          ...state.list.slice(index + 1)
        ]
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./client/redux/modules/ui/toaster/index.js